  import PageIntimass from '../../Components/Intimas-Page/intimass';
  import Agendamento from '../../Components/Banner-Agendamentos/BanAgendamentos';
  import Footer from '../../Components/Footer/Footer';
  
  function Intimas() {
    return (
      <>
        <div id="Intimas">
          <PageIntimass />
        </div>
        <div id="Agendamento">
          <Agendamento />
        </div>
        <div id="Footer">
          <Footer />
        </div>
      </>
    );
  }
  
  export default Intimas;